import { render, staticRenderFns } from "./GeneralSubmissionForm.vue?vue&type=template&id=776791ba"
import script from "./GeneralSubmissionForm.vue?vue&type=script&lang=js"
export * from "./GeneralSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports